import React, { useRef, useState, useEffect, FormEvent } from "react";
import PageHeader from "src/Components/Customer/PageHeader";
import BackIcon from "src/assets/images/back-icon.png";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import SimpleInput from "src/Components/SimpleInput";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import timeIcon from "../../assets/images/time-icon.png";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import SplashScreen from "src/Components/SplashScreen";
import defaultProfile from "src/assets/images/default_profile_image.png";
import { Skeleton } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { loadStripe } from "@stripe/stripe-js";
import visaCard from "src/assets/images/visa-card.png";
import tickIcon from "src/assets/images/checked-icon-modal.png";
import {
  Elements,
  CardCvcElement,
  CardNumberElement,
  CardExpiryElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { CURRENCY } from "src/lib/constans";
import { categorizeTimings } from "src/helpers/helperFunctions";

const stripePromise = loadStripe(
  process.env.REACT_APP_VITE_STRIPE_PK as string
);

interface IDoctoInfo {
  days: string[];
  firstName: string;
  lastName: string;
  gender: string;
  hospitalName: string;
  image: string;
  fees: string;
}

interface ISlots {
  id: string;
  from: string;
  to: string;
  isBooked: boolean;
  isOnline: boolean;
  isPast: boolean;
}

interface IBooking {
  doctorId: string;
  hospitalId: string;
  slotId: string;
  appoinmentDate: string;
  patientName: string;
  phone?: string;
  isOnlineAppoinment: boolean;
  totalAmount: number;
  startTime: string;
  endTime: string;
}

const AppointmentPaymentForm: React.FC<{
  data: IBooking;
  allSlots: ISlots[];
}> = ({ data, allSlots }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [payLoader, setPayLoader] = useState<boolean>(false);
  const [isModal, setIsModal] = useState<boolean>(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!stripe || !elements) {
      console.error("Stripe or Elements not loaded");
      return;
    }

    const cardNumberElement = elements.getElement(CardNumberElement);
    const cardExpiryElement = elements.getElement(CardExpiryElement);
    const cardCvcElement = elements.getElement(CardCvcElement);
    if (!cardNumberElement || !cardExpiryElement || !cardCvcElement) {
      console.error("Card Element(s) not found");
      return;
    }

    setPayLoader(true);
    const { error } = await stripe.createPaymentMethod({
      type: "card",
      card: cardNumberElement,
    });

    if (error) {
      toast(error.message, { type: "error" });
      setPayLoader(false);
      return;
    }
    try {
      const { error: paymentMethodError, paymentMethod } =
        await stripe.createPaymentMethod({
          type: "card",
          card: cardNumberElement,
        });

      if (paymentMethodError) {
        toast(paymentMethodError.message, { type: "error" });
        setPayLoader(false);
        return;
      }

      const paymentIntentResponse = await httpRequest<{
        clientSecret: string;
        paymentIntentId: string;
      }>({
        method: "post",
        path: "/stripe/create-payment-intent",
        params: { currency: CURRENCY, amount: data.totalAmount },
      });

      if (paymentIntentResponse.err) {
        toast(paymentIntentResponse.err, { type: "error" });
        throw new Error(paymentIntentResponse.err);
      }

      const clientSecret = paymentIntentResponse?.res?.clientSecret || "";

      const { paymentIntent, error: confirmError } =
        await stripe.confirmCardPayment(clientSecret, {
          payment_method: paymentMethod.id,
        });

      if (confirmError) {
        toast(confirmError.message, { type: "error" });
        setPayLoader(false);
        return;
      }

      if (paymentIntent?.status === "succeeded") {
        const { res, err } = await httpRequest<any>({
          method: "post",
          path: "/appoiment/booking",
          params: data,
        });
        if (res) {
          setIsModal(true);
        } else {
          toast(err, { type: "error" });
        }
      } else {
        toast("Payment failed. Please try again.", { type: "error" });
      }
    } catch (err) {
      toast("An error occurred during processing. Please try again.", {
        type: "error",
      });
    } finally {
      setPayLoader(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 gap-5">
          <div>
            <label
              className="font-size-16px text-[#000] font-Poppins-Regular flex items-center gap-2"
              htmlFor=""
            >
              Card Number
            </label>
            <div className="visa-card-number relative">
              <img src={visaCard} alt="visa card" />
              <CardNumberElement
                className="stripe-des font-size-16px font-Poppins-Regular paymnet-form-input"
                id="cardNumber"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label
                className="font-size-16px text-[#000] font-Poppins-Regular"
                htmlFor=""
              >
                Expiry Date
              </label>
              <CardExpiryElement
                className="stripe-des font-size-16px font-Poppins-Regular paymnet-form-input"
                id="CardExpiryElement"
              />
            </div>
            <div>
              <label
                className="font-size-16px text-[#000] font-Poppins-Regular"
                htmlFor=""
              >
                CVV
              </label>
              <CardCvcElement
                className="stripe-des font-size-16px font-Poppins-Regular paymnet-form-input"
                id="CardCvcElement"
              />
            </div>
          </div>
        </div>
        <div className="mt-4">
          <PrimaryBtn
            loader={payLoader}
            type="submit"
            ButtonText="Pay now"
            btnExtraStyle={{
              borderRadius: "1.5rem",
              backgroundColor: "#004540",
              marginLeft: "auto",
            }}
          />
        </div>
      </form>
      {isModal && (
        <div className="modal-stripe-overlay">
          <div className="modal-stripe p-6">
            <div className="password-update-success">
              <img src={tickIcon} alt="" />
            </div>
            <h2 className="text-[#2F2F31] leading-tight font-size-40px font-Poppins-SemiBold text-center">
              Your appointment has been booked for
            </h2>
            <p className="font-Poppins-Regular font-size-18px text-[#474747]">
              {moment(data.appoinmentDate).format("MMM DD")},{" "}
              {moment(
                allSlots.find((v) => v.id === data.slotId)?.from,
                "HH:mm"
              ).format("h:mm A")}
            </p>
            <Link
              to="/dashboard"
              className="back-to-home-btn text-white font-size-18px font-Poppins-SemiBold"
            >
              Back To Home
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

const BookDoctorAppointment = () => {
  const navigate = useNavigate();
  const { hid = "", did = "" } = useParams();
  const location = useLocation();
  const { isEdit = false } = location.state || false;
  const { userDetails }: { userDetails: any } = useSelector(
    (store: RootState) => store.appReducer
  );

  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const scrollAmount = 225;

  const getNextAvailableDays = (numDays: number, availableDays: string[]) => {
    const result = [];
    let currentDate = moment().startOf("day");
    for (let i = 0; i < numDays; i++) {
      const dayOfWeek = currentDate.format("dddd").toLowerCase();
      const formattedDate = currentDate.format("YYYY-MM-DD");
      if (availableDays.includes(dayOfWeek)) {
        result.push({
          date: formattedDate,
        });
      }
      currentDate = currentDate.add(1, "days");
    }
    return result;
  };

  const [comment, setComment] = useState<string>("");
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [rescheduleLoader, setRescheduleLoader] = useState<boolean>(false);
  const [slotsLoader, setSlotsLoader] = useState<boolean>(false);
  const [step, setStep] = useState<number>(1);
  const [data, setData] = useState<IDoctoInfo | null>(null);
  const [datesRange, setDatesRange] = useState<{ date: string }[]>([]);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [allSlots, setAllSlots] = useState<ISlots[]>([]);
  const [mySelf, setMySelf] = useState<boolean>(true);

  const [nameError, setNameError] = useState<string>("");
  const [phoneError, setPhoneError] = useState<string>("");

  const [bookSlots, setBookSlots] = useState<IBooking>({
    doctorId: "",
    hospitalId: "",
    slotId: "",
    appoinmentDate: "",
    isOnlineAppoinment: false,
    totalAmount: 0,
    patientName: "",
    phone: "",
    startTime: "",
    endTime: "",
  });

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      const newPosition = Math.max(scrollPosition - scrollAmount, 0);
      setScrollPosition(newPosition);
    }
    const findIndex = datesRange.findIndex((v) => v.date === selectedDate);
    setSelectedDate(datesRange[findIndex - 1].date);
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      const maxScroll =
        scrollContainerRef.current.scrollWidth -
        scrollContainerRef.current.clientWidth;
      const newPosition = Math.min(scrollPosition + scrollAmount, maxScroll);
      setScrollPosition(newPosition);
    }
    const findIndex = datesRange.findIndex((v) => v.date === selectedDate);
    setSelectedDate(datesRange[findIndex + 1].date);
  };

  const handleChange = (
    key: keyof IBooking,
    val: string | boolean | number
  ) => {
    setBookSlots((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleSelectSlot = (item: ISlots) => {
    const { id, isOnline, from, to } = item;
    handleChange("slotId", id);
    handleChange("isOnlineAppoinment", isOnline);
    handleChange("startTime", from);
    handleChange("endTime", to);
    if (!isEdit) {
      setStep(2);
    }
  };

  const moveToConfirm = () => {
    if (!bookSlots.patientName) {
      setNameError("Patient Name is required!");
      return;
    }

    if (!bookSlots.phone) {
      setPhoneError("Patient Phone Number is required!");
      return;
    }
    setNameError("");
    setPhoneError("");
    setStep(3);
  };

  const fetchDoctorInfo = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IDoctoInfo[]>({
      path: `/appoiment/doctor/slots/${did}/${hid}`,
    });
    if (res) {
      setData(res[0]);
      const arr = getNextAvailableDays(30, res[0].days);
      console.log("Dates Range ", arr);

      setDatesRange(arr);
      // if (!isEdit) {
      setSelectedDate(arr[0] ? arr[0].date : null);
      handleChange("totalAmount", Number(res[0].fees) * 100);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const fetchSlots = async (_date: string) => {
    setSlotsLoader(true);
    const { res, err } = await httpRequest<ISlots[]>({
      method: "post",
      path: "/appoiment/doctor/slots",
      params: {
        dateAvalible: moment(new Date(_date)).toISOString(),
        doctotId: did,
        hospitalId: hid,
      },
    });
    if (res) {
      // Get current date and time in PKT (Pakistan Standard Time)
      const currentMoment = moment();
      const currentDate = currentMoment.format("YYYY-MM-DD");
      const currentTime = currentMoment.format("HH:mm");

      // Update isPast flag based on the current date and time
      const updatedSlots = res.map((slot) => {
        const slotDate = moment(_date).format("YYYY-MM-DD");
        const slotTime = slot.from; // Compare with the start time of the slot

        // Check if the slot date is before the current date
        if (moment(slotDate).isBefore(currentDate)) {
          return { ...slot, isPast: true };
        }
        // If the slot is on the current date, check if the start time has passed
        if (slotDate === currentDate && slotTime < currentTime) {
          return { ...slot, isPast: true };
        }
        // Otherwise, keep the original isPast value
        return slot;
      });

      const { afternoonSlots, eveningSlots, morningSlots } =
        categorizeTimings(updatedSlots);
      setAllSlots([
        ...morningSlots,
        ...afternoonSlots,
        ...eveningSlots,
      ]);

      // setAllSlots(updatedSlots);
    } else {
      toast(err, { type: "error" });
    }
    setSlotsLoader(false);
  };

  const reScheduleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setRescheduleLoader(true);
    const { res, err } = await httpRequest<{ message: string }>({
      method: "post",
      path: "/reshedule/slots",
      params: {
        ...bookSlots,
        comment,
        appoinmentId: isEdit?._id,
      },
    });
    if (res) {
      toast(res?.message || "", { type: "success" });
      navigate("/appointments");
    } else {
      toast(err, { type: "error" });
    }
    setRescheduleLoader(false);
  };

  useEffect(() => {
    if (did && hid) {
      fetchDoctorInfo();
      handleChange("doctorId", did);
      handleChange("hospitalId", hid);
    }
  }, [did, hid]);

  useEffect(() => {
    if (isEdit) {
      console.log("isEdit", isEdit);
      console.log("isEdit.appoinmentDate", isEdit.appoinmentDate);
      console.log("isEdit.startTime", isEdit.startTime);
      console.log("isEdit.endTime", isEdit.endTime);
      console.log("isEdit.isOnlineAppoinment", isEdit.isOnlineAppoinment);
      console.log("isEdit.patientName", isEdit.patientName);
      console.log("isEdit.phone", isEdit.phone);
      // setSelectedDate(moment(isEdit.appoinmentDate).format("YYYY-MM-DD"));
      handleChange("patientName", isEdit?.patientName || "");
      handleChange("phone", isEdit?.phone || "");
      handleChange("startTime", isEdit?.startTime || "");
      handleChange("endTime", isEdit?.endTime || "");
      handleChange("isOnlineAppoinment", isEdit?.isOnlineAppoinment || false);
    }
  }, [isEdit]);

  useEffect(() => {
    if (selectedDate && did && hid) {
      fetchSlots(selectedDate);
      handleChange(
        "appoinmentDate",
        moment(new Date(selectedDate)).toISOString()
      );
    }
  }, [selectedDate]);

  useEffect(() => {
    if (!isEdit) {
      if (mySelf) {
        if (userDetails) {
          handleChange(
            "patientName",
            userDetails.firstName + " " + userDetails.lastName
          );
          handleChange("phone", userDetails.mobile);
        }
      } else {
        handleChange("patientName", "");
        handleChange("phone", "");
      }
    }
  }, [mySelf]);

  const containerStyle = {
    transform: `translateX(-${scrollPosition}px)`,
  };

  const BackButton: React.FC = () => {
    return (
      <button
        className="right-bar-icon"
        onClick={() => {
          if (step === 3 || step === 2) {
            setStep((prev) => prev - 1);
          } else {
            navigate(-1);
          }
        }}
        id="book-appointment-back-btn"
      >
        <img src={BackIcon} alt="back-icon" />
      </button>
    );
  };

  let getSlotsDisabled = (item: ISlots) => {
    return item.isBooked || item.isPast || (isEdit ? moment(isEdit.appoinmentDate).format("YYYY-MM-DD") === selectedDate && item.from === isEdit.startTime : false);
  }

  return (
    <>
      <PageHeader
        title="Appointment"
        isButton={true}
        ButtonComponent={BackButton}
      />
      {isLoader && <SplashScreen />}
      {step === 1 ? (
        <div className="parent-box">
          <div className="parent-box">
            {data ? (
              <div className="flex gap-4 align-start">
                <div>
                  <img
                    alt="profile image"
                    width={80}
                    height={80}
                    className="rounded-full profile-image-find-docter"
                    src={`${data.image}`}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      if (target) {
                        target.src = defaultProfile;
                      }
                    }}
                  />
                </div>
                <div className="pb-3">
                  <h4 className="font-size-28px font-Poppins-SemiBold theme-color-green capitalize">
                    {`${data.firstName} ${data.lastName}`}
                  </h4>
                  <p className="font-size-18px font-Poppins-Regular theme-color-green">
                    {data.hospitalName}
                  </p>
                  <span className="font-size-18px font-Poppins-Medium text-[#393939]">
                    Fee: {CURRENCY} {data.fees}
                  </span>
                </div>
              </div>
            ) : (
              <div className="flex gap-4 align-start">
                <Skeleton variant="circular" width={80} height={80} />
                <div className="pb-8" style={{ minWidth: 200 }}>
                  <Skeleton variant="text" sx={{ fontSize: "28px" }} />
                  <Skeleton variant="text" sx={{ fontSize: "20px" }} />
                  <Skeleton variant="text" sx={{ fontSize: "20px" }} />
                </div>
              </div>
            )}
          </div>
          <div className="parent-box">
            <div className="border-b">
              <div className="relative">
                <button
                  disabled={selectedDate === datesRange[0]?.date}
                  className="absolute left-0 left-arrow-top-side"
                  onClick={scrollLeft}
                  id="book-appointment-left-arrow-btn"
                >
                  <FontAwesomeIcon icon={faAngleLeft} />
                </button>
                <button
                  disabled={
                    selectedDate === datesRange[datesRange?.length - 1]?.date
                  }
                  className="absolute right-0 left-arrow-top-side"
                  onClick={scrollRight}
                  id="book-appointment-right-arrow-btn"
                >
                  <FontAwesomeIcon icon={faAngleRight} />
                </button>
                <div className="overflow-x-hidden mx-8">
                  <div
                    ref={scrollContainerRef}
                    className="gap-28 mr-[7rem] flex items-start scroll-container"
                    style={containerStyle}
                  >
                    {datesRange.map((item, index) => (
                      <button
                        onClick={() => setSelectedDate(item.date)}
                        key={item.date}
                        className="flex-shrink-0"
                        id={`book-appointment-date-btn-${index + 1}`}
                      >
                        <p
                          className={`appointment-date font-Poppins-Regular font-size-20px px-3 pt-1 pb-2 cursor-pointer ${
                            item.date === selectedDate && "active"
                          }`}
                        >
                          {moment(item.date).format("DD MMMM")}
                        </p>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="pt-8 pb-6 time-container-find-doctor items-center gap-4 border-b">
              {slotsLoader
                ? Array.from({ length: 4 }).map((_, i) => (
                    <Skeleton key={i} variant="rounded" height={40} />
                  ))
                : allSlots.map((item: ISlots, index: number) => (
                    <button
                      id={`book-appointment-time-btn-${index + 1}`}
                      onClick={() => handleSelectSlot(item)}
                      key={index}
                      disabled={getSlotsDisabled(item)}
                      className={`${
                        getSlotsDisabled(item) ? "disabled" : ""
                      } ${
                        bookSlots?.slotId === item.id && "active"
                      } appointment-time border border-[#878787] px-6 py-2 rounded-md flex items-center justify-center disabled:bg-gray-300 disabled:cursor-not-allowed`}
                    >
                      <p className="font-Poppins-Regular font-size-18px">
                        {`${moment(item.from, "HH:mm").format(
                          "h:mm A"
                        )} to ${moment(item.to, "HH:mm").format("h:mm A")}`}
                      </p>
                    </button>
                  ))}
            </div>
            {isEdit && (
              <div className="py-5">
                <p className="font-Poppins-Regular font-size-20px">Reason</p>
                <form onSubmit={reScheduleSubmit}>
                  <SimpleInput
                    id="book-appointment-reason-input"
                    isRequired={true}
                    value={comment}
                    onChange={(val) => setComment(val)}
                    type="textArea"
                    rows={10}
                    isLimit={1200}
                    maxLength={1200}
                    extraStyle={{ borderColor: "#009d91" }}
                  />
                  <div className="flex justify-end mt-10">
                    <PrimaryBtn
                      loader={rescheduleLoader}
                      type="submit"
                      ButtonText="Save"
                      //   btn
                      btnExtraStyle={{
                        borderRadius: "1.5rem",
                        backgroundColor: "#004540",
                      }}
                    />
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      ) : step === 2 ? (
        <div className="grid grid-cols-[7fr_3fr] gap-2">
          <div className="parent-box">
            <h1 className="font-Poppins-Medium font-size-20px mb-6">
              Appointment for
            </h1>
            <div className="flex gap-4 items-center">
              <button
                onClick={() => setMySelf(true)}
                className={`border font-size-15px font-Poppins-SemiBold health-tabs-main-btn rounded-full ${
                  mySelf
                    ? "text-[#fff] theme-bg-green"
                    : "theme-color-green border-[#004540]"
                }`}
              >
                My Self
              </button>
              <button
                onClick={() => setMySelf(false)}
                className={`border font-size-15px font-Poppins-SemiBold health-tabs-main-btn rounded-full ${
                  !mySelf
                    ? "text-[#fff] theme-bg-green"
                    : "theme-color-green border-[#004540]"
                }`}
              >
                Someone Else
              </button>
            </div>
            <hr className="products-tabs-hr-allOrder" />
            <div className="mb-3">
              <SimpleInput
                readOnly={mySelf ? true : false}
                value={bookSlots.patientName}
                onChange={(val) => handleChange("patientName", val)}
                isLabel={true}
                labelText="Patient Name"
                isRequired={false}
                extraStyle={{ borderColor: "#00A297" }}
              />
              <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                {nameError}
              </p>
            </div>
            <div className="mb-3">
              <SimpleInput
                readOnly={mySelf ? true : false}
                value={bookSlots?.phone || ""}
                onChange={(val) => handleChange("phone", val)}
                type="number"
                isLabel={true}
                labelText="Phone Number"
                isRequired={false}
                extraStyle={{ borderColor: "#00A297" }}
              />
              <p className="font-size-14px font-Poppins-Regular text-[#ff0000]">
                {phoneError}
              </p>
            </div>
            <h1 className="font-Poppins-Medium font-size-20px mb-2">
              Payment method
            </h1>
            <div className="bg-[#ECFFFE] border border-[#00A297] inline-block rounded-md px-4 py-2 text-[#646464] text-center">
              <span className="font-Poppins-Regular font-size-15px mr-6">
                Online payment
              </span>
              <span className="font-Poppins-Regular font-size-18px">
                AED {data?.fees}
              </span>
            </div>
          </div>
          <div className="parent-box h-fit">
            <div className="flex items-start gap-3">
              <img
                alt="profile image"
                className="rounded-full profile-image-find-docter-confirm-booking"
                src={`${process.env.REACT_APP_API_BASEURL}${data?.image}`}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  if (target) {
                    target.src = defaultProfile;
                  }
                }}
              />
              <div className="flex flex-col gap-3">
                <div>
                  <p className="font-size-20px font-Poppins-SemiBold theme-color-green capitalize">
                    {`${data?.firstName} ${data?.lastName}`}
                  </p>
                  <p className="font-size-13px font-Poppins-Regular theme-color-green flex items-center gap-1">
                    {data?.hospitalName}
                  </p>
                </div>
                <div className="rounded-full bg-[#F1F1F1] px-4 py-2 flex items-center gap-1">
                  <span className="mr-2">
                    <img
                      style={{ width: "1vw", height: "1vw" }}
                      src={timeIcon}
                      alt="time icon"
                    />
                  </span>
                  <span className="font-Poppins-Regular font-size-13px text-[#474747]">
                    {moment(bookSlots.appoinmentDate).format("MMM DD")},{" "}
                    {moment(
                      allSlots.find((v) => v.id === bookSlots.slotId)?.from,
                      "HH:mm"
                    ).format("h:mm A")}
                  </span>
                </div>
                <div>
                  <p className="font-Poppins-Medium font-size-20px">
                    Fee: AED {data?.fees}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2 self-start mt-6">
              <PrimaryBtn
                onClick={moveToConfirm}
                type="button"
                ButtonText="Confirm booking"
                btnExtraStyle={{
                  borderRadius: "50rem",
                  padding: 7,
                  background: "#00443F",
                }}
              />
            </div>
          </div>
        </div>
      ) : step === 3 ? (
        <div className="grid grid-cols-[7fr_3fr] gap-2">
          <div className="parent-box">
            <h1 className="font-Poppins-Medium font-size-20px mb-6">
              Payment details
            </h1>
            <Elements stripe={stripePromise}>
              <AppointmentPaymentForm data={bookSlots} allSlots={allSlots} />
            </Elements>
          </div>
          <div className="parent-box h-fit">
            <div className="flex items-start gap-3">
              <img
                alt="profile image"
                className="rounded-full profile-image-find-docter-confirm-booking"
                src={`${process.env.REACT_APP_API_BASEURL}${data?.image}`}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  if (target) {
                    target.src = defaultProfile;
                  }
                }}
              />
              <div className="flex flex-col gap-3">
                <div>
                  <p className="font-size-20px font-Poppins-SemiBold theme-color-green capitalize">
                    {`${data?.firstName} ${data?.lastName}`}
                  </p>
                  <p className="font-size-13px font-Poppins-Regular theme-color-green flex items-center gap-1">
                    {data?.hospitalName}
                  </p>
                </div>
                <div className="rounded-full bg-[#F1F1F1] px-4 py-2 flex items-center gap-1">
                  <span className="mr-2">
                    <img
                      style={{ width: "1vw", height: "1vw" }}
                      src={timeIcon}
                      alt="time icon"
                    />
                  </span>
                  <span className="font-Poppins-Regular font-size-13px text-[#474747]">
                    {moment(bookSlots.appoinmentDate).format("MMM DD")},{" "}
                    {moment(
                      allSlots.find((v) => v.id === bookSlots.slotId)?.from,
                      "HH:mm"
                    ).format("h:mm A")}
                  </span>
                </div>
                <div>
                  <p className="font-Poppins-Medium font-size-20px">
                    Fee: AED {data?.fees}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default BookDoctorAppointment;
